import { UserLanguageType } from "@Components/Modules/Helpers";

export default {
    AboutUs: "O goodie",
    Contact: "Kontakt",
    Copyright: `${new Date().getFullYear()} © Millennium Goodie Sp. z o.o. Wszelkie prawa zastrzeżone`,
    ForPartners: "goodie dla Firm",
    Help: "Pomoc",
    PrivacyPolicy: "Polityka prywatności",
    PrivacySettings: "Ustawienia prywatności",
    Rules: "Regulaminy",
    SitemapIndex: "Mapa strony",
    Accessibility: "Deklaracja dostępności",
    GoodieDescription:
        "<b>goodie</b> to nowoczesna, przyjazna i bezpłatna aplikacja mobilna oraz platforma internetowa, w której znajdziesz zawsze aktualne kody rabatowe, najnowsze gazetki Twoich ulubionych sklepów, atrakcyjne oferty cashback, zniżki, kupony promocyjne i wyprzedaże. Aplikacja goodie pomoże Ci również w trakcie zakupów oferując listy zakupowe, programy lojalnościowe czy możliwość wirtualizacji kart lojalnościowych. goodie - mądry sposób na zakupy!",
    languageId: UserLanguageType.Polish,
};
